const styles = {
  curvedShadow: {
    display: 'block',
    width: '100%',
    height: '5px',
    //backgroundImage: "url('../../../assets/images/curved-shadow.svg')",
    opacity: '0.08',
    backgroundRepeat: 'no-repeat',
    content: '',
  },
};
export default styles;



// WEBPACK FOOTER //
// ./src/app/components/UI_Elements/ShadowSeparator.styles.js